import React, { Component, useState } from 'react'
import { connect } from "react-redux";
import { Switch, Route, Redirect, Link } from "react-router-dom";
import * as auth from "../../store/ducks/auth.duck";
import axios from "axios";
import SweetAlert from 'react-bootstrap-sweetalert';
import { Field, FieldArray, reduxForm, getFormValues } from 'redux-form'
import Loader from 'react-loader-advanced';
import Login from "../auth/Login";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import clsx from "clsx";
import Footer from "./../../../_metronic/layout/footer/Footer";
import { Helmet } from 'react-helmet'

library.add(fas)


const validate = values => {
  const errors = {}
  const requiredFields = [
    'newPassword',
    'confirmPassword',
  ]
  requiredFields.forEach(field => {
    if(field =='newPassword' && !values[field]){
      errors[field] = 'Please enter password'
    }
    else if(field =='confirmPassword' && !values[field]){
      errors[field] = 'Please enter confirm password'
    }
    else if (!values[field]) {
      errors[field] = 'This field is required'
    }
  })
  if (values.confirmPassword  != values.newPassword){
    errors.confirmPassword = 'Password and confirm password do not match';
  }
  if (values.newPassword && !/^\S*$/i.test(values.newPassword)) {
    errors.newPassword = 'Please enter valid password'
  }
  if (values.confirmPassword && !/^\S*$/i.test(values.confirmPassword)) {
    errors.confirmPassword = 'Please enter valid confirm password'
  }
  return errors
}

const renderField = ({
  input,
  label,
  type,
  disabled,
  meta: { asyncValidating, touched, error }
}) => (
    <div className="formgroup">
      <label className="custom-label"></label>
      <div className={asyncValidating ? 'async-validating' : ''}>
        <input {...input} type={type} placeholder={label} disabled={disabled} className="form-control" />
        {touched && error && <span className="error-msg">{error}</span>}
      </div>
    </div>
  )
  
class ResetPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
        newPassword: null,
        confirmPassword: null,
        email: null,
        alert: null,
        isSave:false,
        validPassword: false
    }
  }
  async componentDidMount() {
    let url = new URLSearchParams(this.props.location.search)
    this.setState({
      email:url.get("emailid"),
      token:url.get("Token")
    })
    await this.checkResetPasswordRequest(url.get("emailid"), url.get("Token"))
  }
  checkResetPasswordRequest = async (email, token) => {
    const options = {
      headers: {
        'content-type': 'application/json',
      },
      params:{
        "Email": email,
        "Token": token
     }
    };
    axios.get(`${process.env.REACT_APP_API_URL}api/user/checkresetpasswordrequest`, options).then((result)=>{
      if(!result.data.success || result.data.success==false){
        this.passwordAlert("Your reset password link is expired. Please try again.", 'error');
      }
    });
  };
  onSubmitPassword = (formProps) => {
    
    this.setState({isSave:true})
     this.props.resetPasswordRequest({
        newPassword: formProps.newPassword,
        confirmPassword: formProps.confirmPassword,
        email: this.state.email,
        token: this.state.token
    });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.response) {
      this.setState({isSave:false})
      if(nextProps.response.success) {
        if (nextProps.response && nextProps.response != this.props.response) {
          this.passwordAlert("Your password has been reset successfully!", 'success');
          this.setState({
            email:'',
            token:''
          })
        }
      }
      else {
        let msg = 'something went wrong';
        if (nextProps.response && nextProps.response != this.props.response) {
          this.passwordAlert(msg, 'error');
        }
      }
    }
  }

  passwordAlert(msg, type) {
    let getAlert = '';
    if(type == 'success') {
      getAlert = () => (
        <SweetAlert 
          success 
          title={msg}
          onConfirm={() => this.hideAlert()}
        >
        </SweetAlert>
      );
  
    } else{ 
      getAlert = () => (
        <SweetAlert 
          error 
          title={msg}
          onConfirm={() => this.hideAlert()}
        >
        </SweetAlert>
      );
    }

    this.setState({
      alert: getAlert()
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
    this.setState({validPassword: true});
  }

  render() {
    const {handleSubmit, pristine, reset, submitting , formValues} = this.props;
    const {loading} = this.props;
    const spinner = <span  className="loader"></span>;
    if(this.state.validPassword) {
        return (<Redirect exact={true} to="/auth/login" component={Login}  />);
    }
    return (
      <>
      <Helmet>
        <title>Reset Password | Scorecard</title>
      </Helmet>
        <div className="kt-login__body log-in">
        <div className="kt-login__form">
          <div className="m-login__logo">
            <center>
              <a href="#">
                <img src="/images/referral-new-logo.png" />
              </a>
            </center>
          </div>
          <div>
            <div className="login-header">
              <FontAwesomeIcon icon={["fas", "lock"]} color="white" />
              <span className="reset-password-title">Reset Password</span>
            </div>
          <div className="reset-pass mt-30">
                {this.state.alert}
                {/* <!-- Form Elements --> */}
                <div className="Change-pass">
                <Loader show={loading} message={spinner}>
        
                <form 
                className="pad-20"
                onSubmit={handleSubmit(this.onSubmitPassword)} >
                  <div className="login-body">
                    <div className="formgroup email-field">
                      <Field
                          margin="normal"
                          label="New Password"
                          name="newPassword"
                          type="password"
                          component={renderField}
                          style={{ whiteSpace: 'nowrap' }}
                      />
                    </div>
                    <div className="formgroup">
                    <Field
                        margin="normal"
                        label="Confirm New Password"
                        name="confirmPassword"
                        type="password"
                        component={renderField}

                    />
                    </div>
                    </div>
                    <div className="login-footer mt-3">
                        <button
                          id="kt_login_signin_submit"
                          type="submit"
                          className={`btn btn-primary btn-elevate kt-forgot__btn-primary  ${clsx(
                            {
                              "kt-spinner kt-spinner--right pr-5 kt-spinner--md kt-spinner--light": this.state.isSave
                            }
                          )}`}
                        >
                          Reset Password
                          </button>
                          <Link
                              id="cancel-reset-password" className="btn btn-primary btn-elevate kt-cancel__btn-primary" to="/auth/login">
                              Cancel
                          </Link>
                      </div>
                </form>
               
                </Loader>
                {/* <!-- Form Elements End--> */}
                </div>
            </div>
          </div>
        </div>
        </div>
        <Footer/>
      </>
    );
  }
}

ResetPassword = reduxForm({
  form: 'ResetPassword' ,
   validate,
  enableReinitialize: true,
  destroyOnUnmount: true
})(ResetPassword);

function mapStateToProps(state, props){
  return {
    initialValues: { 
        newPassword: null,
        confirmPassword: null,
        email:null,
        token:null
    },
    response: state.auth.response,
    loading: state.auth.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPasswordRequest: ({
        newPassword,
        confirmPassword,
        email,
        token
    }) =>  dispatch(auth.actions.resetPasswordRequest({
        newPassword: newPassword.replace(/\s/g, ''),
        confirmPassword: confirmPassword.replace(/\s/g, ''),
        newPassword,
        confirmPassword,
        email,
        token
    })),
  }
} 

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
